// extracted by mini-css-extract-plugin
module.exports = {"empty":"styles_empty__1d1O_","empty__icon":"styles_empty__icon__2yt12","empty__content":"styles_empty__content__3-nRM","empty__subtitle":"styles_empty__subtitle__3CY3h"};